import React, { useEffect, useState } from "react";
import Image from "../../images/hero_1.jpg";
import { Link } from "react-router-dom";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import "./appliedJobs.css";
import CircularProgress from "@mui/material/CircularProgress";

const AppliedJobs = () => {
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAppliedJobs = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/user/getAppliedJobs");
      console.log(data);
      setAppliedJobs(data.appliedJobs);
      setLoading(false);
      console.log(data);
    } catch (error) {
      toast.error(error.response.data.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAppliedJobs();
  }, []);

  console.log(appliedJobs);
  return (
    <>
      <section
        class="section-hero overlay inner-page bg-image"
        style={{
          backgroundImage: `url(${Image})`,
        }}
        id="home-section"
      >
        <div class="container">
          <div class="row ">
            <div class="col-md-7 mt-5">
              <h1 class="text-white font-weight-bold">Applied Jobs</h1>
              <div class="custom-breadcrumbs">
                <Link style={{ textDecoration: "none" }} to="/">
                  Home
                </Link>{" "}
                <span class="mx-2 slash">/</span>
                <span class="text-white">
                  <strong>Applied Jobs</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {loading && <CircularProgress />}
      {appliedJobs?.length === 0 && (
        <h1 style={{ textAlign: "center", marginTop: "20px" }}>
          No Jobs Applied Yet!
        </h1>
      )}
      <div className="cardss">
        {appliedJobs?.length > 0 &&
          appliedJobs?.map((job) => (
            <div className="cardc">
              <img src={job.joblogo ? job.job.joblogo : Image} />
              <div className="cardContentc">
                <p className="jobHeader">{job.job.company.name}</p>
                <div className="cardDescription">
                  <div className="JobDescription">
                    <ul>
                      <li>
                        <span>Position: </span> {job.job.position}
                      </li>
                      <li>
                        <span>Location: </span> {job.job.jobLocation}
                      </li>
                    </ul>
                  </div>
                  <div className="JobDescription">
                    <ul>
                      <li>
                        <span>JobType: </span>
                        {job.job.jobType}
                      </li>
                      <li>
                        <span>Salary: </span>
                        {job.job.minSalary}-{job.job.maxSalary}$
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <span className={job.status === "pending" ? "status" : "status1"}>
                {job.status}
              </span>
            </div>
          ))}
      </div>
    </>
  );
};

export default AppliedJobs;
